import type { SVGProps } from 'react';
import { memo } from 'react';

import { SVG_STOROKE_SIZE } from '@/data/shared/constant';

import { IconSizeType } from '@/types/icon';

interface SvgIconProps extends SVGProps<SVGSVGElement> {
  size: IconSizeType;
}
const SvgIconCommentLine = ({ size = 24, ...props }: SvgIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill="none"
    viewBox="0 0 24 24"
    className="svgr-icon-component"
    strokeWidth={SVG_STOROKE_SIZE[size]}
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M5 12a7 7 0 1 1 12.83 3.874 1 1 0 0 0-.104.906l.566 1.51-1.51-.566a1 1 0 0 0-.905.104A7 7 0 0 1 5 12Zm7-9a9 9 0 1 0 4.542 16.77l3.108 1.165a1 1 0 0 0 1.287-1.287l-1.165-3.108A9 9 0 0 0 12 3Zm-3 9a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm4 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm3 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
      clipRule="evenodd"
    />
  </svg>
);
const Memo = memo(SvgIconCommentLine);
export default Memo;
